import React from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { Card, Table, Button } from "reactstrap";
import { ADMIN_AGENCY_DETAILS } from "../../../constants/RoutePaths";

export default function RecentAgencies(props) {
  const { recentAgency = [],loading } = props;
  return (
    <Fragment>
      <div className="page-title">
        <h4>Recent Agency</h4>

        <div className="top-btn">
          <Link
            to={{
              pathname: "/admin/agency",
            }}
          >
            <Button size="sm" color="primary">
              See all
            </Button>
          </Link>
        </div>
      </div>
      <Card body className="mt-4">
        <Table hover responsive>
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading?"":recentAgency.length === 0
              ?<tr><td colSpan={3} ><center>No Records found </center></td></tr> 
              : recentAgency.map((data) => {
                  const { agencyName, agencyEmail, agencyId } = data;
                  return (
                    <tr key={agencyId}>
                      <td>{agencyName}</td>
                      <td>{agencyEmail}</td>
                      <td>
                        <Link to={`${ADMIN_AGENCY_DETAILS}/${agencyId}`}>
                          <Button className="table-btn" color="link">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16.216"
                              height="10.811"
                              viewBox="0 0 16.216 10.811"
                            >
                              <path
                                id="Icon_awesome-eye"
                                data-name="Icon awesome-eye"
                                d="M16.118,9.494A9.03,9.03,0,0,0,8.108,4.5,9.031,9.031,0,0,0,.1,9.495a.911.911,0,0,0,0,.822,9.03,9.03,0,0,0,8.01,4.994,9.031,9.031,0,0,0,8.01-4.995A.911.911,0,0,0,16.118,9.494Zm-8.01,4.465a4.054,4.054,0,1,1,4.054-4.054A4.054,4.054,0,0,1,8.108,13.959Zm0-6.757a2.683,2.683,0,0,0-.713.107A1.347,1.347,0,0,1,5.512,9.193a2.7,2.7,0,1,0,2.6-1.99Z"
                                transform="translate(0 -4.5)"
                                fill="#1b3e6f"
                              />
                            </svg>
                          </Button>
                        </Link>
                      </td>
                    </tr>
                  );
                })}
          </tbody>
        </Table>
      </Card>
    </Fragment>
  );
}
